module.exports = __webpack_public_path__ + "img/copy2.0a36ef20.svg";